var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { LetrRequestType } from "@/share/Letr";
import { Group } from "@@/Group";
import { LeterPermissionType } from "@@/Letr";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { ContactDialogState } from "./ContactDialogState";
import { MultiChoiceMenuState } from "../UIComponents/MultSelectChoice";
import { OrgContactListState } from "../UIComponents/OrgContactsList";
export class NewLetrDialogState {
    constructor() {
        this.open = false;
        this.subject = "";
        this.editting = false;
        this.chat = false;
        this.basedialogState = new BaseDialogState();
        this.multiChoiseState = new MultiChoiceMenuState();
        this.hiddenMultiChoiseState = new MultiChoiceMenuState();
        this.connectsMultiChoiceState = new MultiChoiceMenuState();
        this.selectedGroup = new Map();
        this.hiddenSelectedGroup = new Map();
        this.message = "";
        this.messagecolor = "green";
        this.selectedEditGroup = new Set();
        this.selectedConnects = new Set();
        this.connectemailhint = "";
        this.showconnectpasswordscreen = false;
        this.connectpasswords = new Map();
        this.selectedorgcontacts = new Set();
        this.orgcontactstate = new OrgContactListState();
        this.mode = "letr";
        this.activeletrid = "";
        this.storinghints = false;
        this.connecthints = new Map();
        this.storedHintResuls = new Map();
        this.contactdialogstate = new ContactDialogState();
        this.hiddencontactdialogstate = new ContactDialogState();
        makeObservable(this);
        this.basedialogState.setHeaderLabel("New Letr");
        this.basedialogState.setOkLabel("Create");
        this.basedialogState.onOk = () => this.createNewLetr();
        this.basedialogState.onClose = () => {
            this.setOpen(false);
            this.resetallgroups();
        };
        this.multiChoiseState.setLabel("Select Users");
        this.hiddenMultiChoiseState.setLabel("Select Hidden Users");
        this.connectsMultiChoiceState.setLabel("Select Connects");
        this.orgcontactstate.onSelecCb = () => {
            this.checkAndEnableCreate();
        };
        this.contactdialogstate.onSelecCb = () => {
            this.checkAndEnableCreate();
        };
        APPEvent.addSubscriberForAddConnectPasswordhint((hints) => {
            if (!this.storinghints) {
                return;
            }
            if (hints !== undefined) {
                const hmap = new Map();
                // we need to show the message for each one now!
                hints.forEach((hn) => hmap.set(hn.connectid, hn));
                this.connecthints.forEach((k) => {
                    const hr = hmap.get(k.id);
                    if (hr !== undefined) {
                        this.addHintStorePasswordResult(hr);
                    }
                    else {
                        this.addHintStorePasswordResult({ letrid: this.activeletrid, success: false, connectid: k.id });
                    }
                });
            }
            else {
                this.connecthints.forEach((k) => {
                    this.addHintStorePasswordResult({ letrid: this.activeletrid, success: false, connectid: k.id });
                });
            }
            this.setStoringHints(false);
        });
        APPEvent.addSubscriberForLetrsResponse((res) => {
            if (res.type === LetrRequestType.Add && this.editting) {
                this.basedialogState.setDisableOkButton(false);
                this.setEditting(false);
                if (res.cpassword.length > 0 && res.letrs.length > 0) {
                    this.setConnectPasswords(res.cpassword);
                    this.activeletrid = res.letrs[0].id;
                    this.setShowConnectpasswordScreen(true);
                    this.resetallgroups();
                    this.mode = "hints";
                }
                else {
                    this.setOpen(false);
                }
            }
        });
    }
    getStorePasswordHint(id) {
        return this.storedHintResuls.get(id);
    }
    addHintStorePasswordResult(res) {
        this.storedHintResuls.set(res.connectid, res);
    }
    setStoringHints(storing) {
        this.storinghints = storing;
    }
    addConnectHints(hints) {
        this.connecthints.set(hints.id, hints);
        this.checkAndEnableCreate();
    }
    removeConnectHints(id) {
        this.connecthints.delete(id);
        this.checkAndEnableCreate();
    }
    resetallgroups() {
        this.setSubject("");
        this.hiddenSelectedGroup.clear();
        this.basedialogState.setHideFooter(false);
        this.selectedGroup.clear();
        this.contactdialogstate = new ContactDialogState();
        this.hiddencontactdialogstate = new ContactDialogState();
    }
    reset() {
        this.resetallgroups();
        this.connecthints.clear();
        this.connectpasswords = new Map();
        this.selectedConnects.clear();
        this.mode = "letr";
        this.setStoringHints(false);
        this.clearPasswordHintResult();
    }
    setConnectPasswords(pwds) {
        this.connectpasswords = new Map();
        pwds.forEach((pw) => this.connectpasswords.set(pw.id, pw));
    }
    setShowConnectpasswordScreen(show) {
        this.showconnectpasswordscreen = show;
    }
    setConnectEmailHint(hint) {
        this.connectemailhint = hint;
    }
    removeConnect(email) {
        this.selectedConnects.delete(email);
        this.checkAndEnableCreate();
    }
    addConnect(email) {
        this.selectedConnects.add(email);
        this.checkAndEnableCreate();
    }
    createNewLetr() {
        var _a;
        if (this.mode === 'hints') {
            this.setStoringHints(true);
            setTimeout(() => {
                var _a, _b, _c;
                return (_a = this.basedialogState.dialogref.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                    top: (_c = (_b = this.basedialogState.dialogref.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) !== null && _c !== void 0 ? _c : 1000
                });
            }, 10);
            this.createPasswordHints();
            return;
        }
        if (!(this.chat || this.subject)) {
            return;
        }
        this.setEditting(true);
        setTimeout(() => {
            var _a, _b, _c;
            return (_a = this.basedialogState.dialogref.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                top: (_c = (_b = this.basedialogState.dialogref.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) !== null && _c !== void 0 ? _c : 1000
            });
        }, 10);
        const perm = [];
        this.selectedGroup.forEach((gp, id) => {
            perm.push({
                userid: id, permission: this.selectedEditGroup.has(id) ?
                    LeterPermissionType.Edit : LeterPermissionType.View,
                roleid: ''
            });
        });
        this.hiddenSelectedGroup.forEach((gp, id) => {
            perm.push({
                userid: id, permission: LeterPermissionType.View,
                roleid: ''
            });
        });
        (_a = this.createCb) === null || _a === void 0 ? void 0 : _a.call(this, this.subject, perm, Array.from(this.hiddenSelectedGroup.keys()), Array.from(this.orgcontactstate.selectedContacts), this.connectemailhint);
    }
    checkAndEnableCreate() {
        this.basedialogState.setDisableOkButton(false);
    }
    setChat(chat) {
        this.chat = chat;
    }
    setSubject(subject) {
        this.subject = subject;
        this.checkAndEnableCreate();
    }
    setEditting(editting) {
        this.editting = editting;
    }
    setMessage(msg) {
        this.message = msg;
    }
    setMessageColor(color) {
        this.messagecolor = color;
    }
    addGroup(grp) {
        this.selectedGroup.set(grp.id, grp);
        this.removeHiddenGroup(grp);
        this.hiddenMultiChoiseState.setSelection(grp.id, false);
        this.checkAndEnableCreate();
    }
    addHiddengroup(grp) {
        this.hiddenSelectedGroup.set(grp.id, grp);
        this.removegGroup(grp);
        this.multiChoiseState.setSelection(grp.id, false);
    }
    removegGroup(grp) {
        this.selectedGroup.delete(grp.id);
        this.checkAndEnableCreate();
    }
    removeHiddenGroup(grp) {
        this.hiddenSelectedGroup.delete(grp.id);
    }
    setOpen(open) {
        this.open = open;
        if (this.chat) {
            this.basedialogState.setHeaderLabel("Wing");
        }
        else {
            this.basedialogState.setHeaderLabel("New Letr");
        }
        this.basedialogState.setOpen(open);
        this.setShowConnectpasswordScreen(false);
        if (!this.open) {
            this.reset();
        }
        else {
            this.orgcontactstate.reset();
            if (!this.chat) {
                this.orgcontactstate.reload = true;
            }
        }
    }
    getSelectedGroups() {
        return Array.from(this.selectedGroup.values());
    }
    getHiddenSelectedGroups() {
        return Array.from(this.hiddenSelectedGroup.values());
    }
    getSelectedConnects() {
        return Array.from(this.selectedConnects);
    }
    addEditGroup(grp, checked) {
        if (checked) {
            this.selectedEditGroup.add(grp.id);
        }
        else {
            this.selectedEditGroup.delete(grp.id);
        }
    }
    createPasswordHints() {
        const req = [];
        for (const [hint, value] of this.connecthints) {
            req.push({
                letrid: this.activeletrid,
                connectpassword: value
            });
        }
        this.clearPasswordHintResult();
        Apphandler.sendMessage("createpasswordhints", req);
    }
    clearPasswordHintResult() {
        this.storedHintResuls.clear();
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], NewLetrDialogState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewLetrDialogState.prototype, "subject", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewLetrDialogState.prototype, "editting", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewLetrDialogState.prototype, "chat", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], NewLetrDialogState.prototype, "selectedGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], NewLetrDialogState.prototype, "hiddenSelectedGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewLetrDialogState.prototype, "message", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewLetrDialogState.prototype, "messagecolor", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], NewLetrDialogState.prototype, "selectedEditGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], NewLetrDialogState.prototype, "selectedConnects", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], NewLetrDialogState.prototype, "connectemailhint", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewLetrDialogState.prototype, "showconnectpasswordscreen", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], NewLetrDialogState.prototype, "connectpasswords", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], NewLetrDialogState.prototype, "selectedorgcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewLetrDialogState.prototype, "storinghints", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], NewLetrDialogState.prototype, "connecthints", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], NewLetrDialogState.prototype, "storedHintResuls", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "addHintStorePasswordResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setStoringHints", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "addConnectHints", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "removeConnectHints", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "resetallgroups", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setConnectPasswords", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setShowConnectpasswordScreen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setConnectEmailHint", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "removeConnect", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "addConnect", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setChat", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setSubject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setEditting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setMessageColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "addGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "addHiddengroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "removegGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "removeHiddenGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group, Boolean]),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "addEditGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], NewLetrDialogState.prototype, "clearPasswordHintResult", null);
